import type { components } from "@/services/customer-schema";
import type { RequiredWithdrawalAddresses } from "@/services/withdrawal/withdrawalAddressesApi";
import { faker } from "@faker-js/faker";

faker.seed(0);

export const withdrawalAddress = (): RequiredWithdrawalAddresses[number] => {
  const asset = faker.helpers.arrayElement([
    "BTC",
    "ETH",
    "SOL",
    "USDT",
    "USDC",
  ]);
  let blockchain: components["schemas"]["Blockchain"];
  let address: string;
  const clientReference: components["schemas"]["ClientReference"] =
    faker.string.numeric(10);

  switch (asset) {
    case "BTC":
      blockchain = "BITCOIN";
      address = faker.finance.bitcoinAddress({ type: "bech32" });
      break;
    case "SOL":
      blockchain = "SOLANA";
      address = faker.string.alphanumeric(44); // fake a Solana-style address
      break;
    default:
      blockchain = "ETHEREUM";
      address = faker.finance.ethereumAddress();
      break;
  }

  return {
    id: faker.string.uuid(),
    label: faker.commerce.productName(),
    reference: clientReference,
    address,
    blockchain,
    beneficiary: {
      name: faker.person.fullName(),
    },
    status: faker.helpers.arrayElement([
      "APPROVED",
      "PENDING",
      "REJECTED",
      "WITHDRAWN",
    ]) as string,
    createdBy: {
      username: faker.person.fullName(),
      id: faker.string.uuid(),
    },
    createdAt: faker.date.past().toISOString(),
    rejectionReason: "because",
    travelRule: {
      isSelfHostedWallet: false,
      confirmBeneficiaryOwnsWallet: false,
      beneficiary: {
        clientReference,
        personDetails: {
          personType: "NATURAL",
          naturalPersonPrimaryIdentifier: faker.person.lastName(),
          naturalPersonSecondaryIdentifier: faker.person.firstName(),
          buildingNumber: faker.location.buildingNumber(),
          buildingName: faker.location.secondaryAddress(),
          streetName: faker.location.street(),
          town: faker.location.city(),
          country: faker.location.countryCode("alpha-2"),
        },
      },
    },
  };
};

const numWithdrawalAddresses = 20;

export const withdrawalAddresses: RequiredWithdrawalAddresses[number][] =
  Array.from({ length: numWithdrawalAddresses }, () => withdrawalAddress());

delete withdrawalAddresses[0].label;

export const withdrawalAddressesResponse = {
  addresses: withdrawalAddresses,
  pagination: {
    limit: numWithdrawalAddresses,
    firstCursor: "abc123",
    nextCursor: "def456",
    lastCursor: "def456",
  },
};

export const withdrawalAddressResponse = withdrawalAddress();
